import { ReactElement } from 'react';

interface markup {
  __html: string;
}

const createMarkup = (setHtml: string): markup => ({ __html: setHtml });

export const TextHtml = ({ html }): ReactElement => <div dangerouslySetInnerHTML={createMarkup(html)} />;
